import { useLayoutEffect, useRef } from 'react';

export const useScript = (id: string, src?: string, async = true, type = 'module') => {
  const ref = useRef<HTMLScriptElement>();

  useLayoutEffect(() => {
    const remove = () => {
      if (ref.current) {
        ref.current.remove();
        ref.current = undefined;
      } else {
        const existing = document.getElementById(id);
        existing?.remove();
      }
    };

    const add = () => {
      if (!src) {
        return;
      }
      const element = document.createElement('script');
      element.id = id;
      element.src = src;
      element.async = async;
      element.type = type;
      document.body.appendChild(element);
    };

    remove();
    add();

    return () => {
      remove();
    };
  }, [async, id, src, type]);
};
